module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAmElEQVR42mNgGAogYQEq/5KLy390jK4enzzFgG4OIMbn2CyiWQjQzQHk+BwZUz0EkA36FdGEExMKGYp9js9yQo6gqc+JcQjNfU7IEfjso6rPcTmCrGxGqeWEogIjJKhtOTbH0M3npKSJwecAajmG7IKJFg6gWwFEigNwlgcjJgRGHTDqgFEHjDqAovY/qXhoOWDQ9ILpYT4AosUTbUIzHAQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/no_activas_uni_con.png
// module id = qqVq
// module chunks = 0